<template>
  <model>
    <img :src="pic" />
  </model>
</template>

<script>
import qrcode1 from '@/assets/images/qrcode.png';

export default {
  name: 'qrcode',
  data() {
    return {
      pic: qrcode1,
    };
  },
};
</script>

<style lang="scss" scoped>
img {
  // @include w(571);
  width: 70%;
  position: absolute;
  top: 15vh;
  left: 50%;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  z-index: 11;
  padding-top: vw2rem(5);
  padding-bottom: vw2rem(6);
  // background-color: #fff;
}
</style>
